import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import RoutesserviceService from '../routesservice.service';
import { HeaderService } from '../header.service';



const httpOptions = new HttpHeaders()
  .set('content-type', 'application/json');

@Injectable({
  providedIn: 'root'
})
export class AnnouncementService {

  constructor(
    private httpClient: HttpClient,
    private Customeroutes: RoutesserviceService,
    private HeaderService: HeaderService
  ) { }

  async storeCategory(data: any) {
    const sdata = {
      category_name: data.category_name,

    }
    return this.httpClient
      .post(this.Customeroutes.createCategory(), sdata, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
      });
  }
  async getAllCategory() {
    return this.httpClient
      .post(this.Customeroutes.getCategory(), '', {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        return data;
      });
  }


  async addsAnnouncement(formData: FormData) {
    const httpFormDataOptions = new HttpHeaders();
    return this.httpClient
      .post(this.Customeroutes.addAnnouncement(), formData, {
        headers: this.HeaderService.getHeaderWithTokenWithOutContentType(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        // Laravel returns { message: "...", data: {...} }
        return data;
      })
      .catch((error) => {
        return error.error; // return validation errors, etc.
      });


  }


  async editAnnouncement(formData: FormData) {
    const httpFormDataOptions = new HttpHeaders();
    return this.httpClient
      .post(this.Customeroutes.editAnnouncement(), formData, {
        headers: this.HeaderService.getHeaderWithTokenWithOutContentType(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        // Laravel returns { message: "...", data: {...} }
        return data;
      })
      .catch((error) => {
        return error.error; // return validation errors, etc.
      });


  }



  async getAnnouncement(filters:any) {
    return this.httpClient
      .post(this.Customeroutes.getAnnouncements(), filters, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        return data;
      });
  }


  getAnnouncementDataForEdit(id: any) {

    return this.httpClient
      .get(this.Customeroutes.getOneAnnouncementForEdit(id), {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),

      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data) {

          return data;
        }
        return data;
      });

  }

  async deleteAnnouncements(_id: any) {
    const sdata = {
      id: _id,

    }
    return this.httpClient
      .post(this.Customeroutes.deleteAnnouncements(), sdata, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        return data;
      });
  }



    async addReaction(announcementId:any,reaction:any) {
       const sdata = {
      annoucment_id: announcementId,
      reaction:reaction

    }
    return this.httpClient
      .post(this.Customeroutes.addReactionAnnouncements(), sdata, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        return data;
      });
  }

}
